import { jsx as o } from "react/jsx-runtime";
import { useStyleConfig as s, chakra as t } from "@chakra-ui/react";
import { SgiLogoSvg as i } from "./SgiLogoSvg.mjs";
import { SgiLogoSvgCondensed as a } from "./SgiLogoSvgCondensed.mjs";
const m = ({ isCondensed: r = !1, variant: e = "colour", ...g }) => {
  const n = s("SgiLogo", { variant: e });
  return /* @__PURE__ */ o(
    t.span,
    {
      __css: n,
      role: "img",
      "aria-label": "Saskatchewan Government Insurance logo",
      ...g,
      children: r ? /* @__PURE__ */ o(a, {}) : /* @__PURE__ */ o(i, {})
    }
  );
}, p = ({ ...r }) => /* @__PURE__ */ o(m, { ...r });
export {
  p as Logo,
  m as SgiLogo
};
